import React from "react";
import Notifications from "./Notifications";

interface CommonErrorBannerProps {
    heading: string;
    messageInfo: string;
    variant?: "Error" | "Success" | "Informational" | "Alert";
}

const CommonErrorBanner: React.FC<CommonErrorBannerProps> = ({
    heading,
    messageInfo,
    variant = "Error",
}) => {
    return (
        <div className="padding-bottom-2u margin-top-4u desktop:mt-18! tablet:mt-12.5! mobile:mt-8!">
            <div className="w-[80%]">
                <Notifications variant={variant} heading={heading} messageInfo={messageInfo} />
            </div>
        </div>
    );
};

export default CommonErrorBanner;
